module.exports = __webpack_public_path__ + "img/img011.f872e3d4.png";